import cx from 'classnames';
import { compose, withProps, setDisplayName } from 'recompose';
import { defaultScaleSize } from 'sharedParts/config/blockConfig/questionScale';
import styles from './withScaleRatingItemStyle.scss';

const getItemtWidthStyle = (itemsCount) => {
  switch (itemsCount) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      return styles['default-width'];
    case 6:
      return styles['mid-width-3'];
    case 7:
      return styles['mid-width-2'];
    case 8:
      return styles['mid-width-1'];
    case 9:
    case 10:
      return styles['min-width'];
    default:
      return styles['default-width'];
  }
};

export default compose(
  setDisplayName('withScaleRatingItemStyle'),
  withProps(({ block: { size = defaultScaleSize }, itemListCount }) => {
    return {
      ratingContainerClassName: styles.container,
      ratingItemClassName: cx(styles.ratingItem, styles[size], getItemtWidthStyle(itemListCount)),
    };
  }),
);
